import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getPdb } from "../../api/ApiService";
import { routesConfig } from "../../config/routes";
import { EpiId } from "../../shared/enums/LinkEpiId";
import { WizardStepIndex } from "../../shared/enums/WizardStep";
import { cookies } from "../../shared/helpers/cookies";
import { action } from "../../store/action";
import { useCartOptional } from "../../store/hooks/useCartOptional";
import { useCartProduct } from "../../store/hooks/useCartProduct";
import { useEpiserverLink } from "../../store/hooks/useEpiServerLink";
import { useIsLoadedFromSummary } from "../../store/hooks/useIsLoadedFromSummary";
import { useMachineTonnage } from "../../store/hooks/useMachineTonnage";
import ContactUsForm from "../ContactUs/ContactUsForm";
import ProductsList from "../ContactUs/ProductsList";
import RetailerLink from "../ContactUs/RetailerLink";
import DisclamerText from "../shared/DisclamerText";
import "./ContactUsStep.scss";
import WizardContainer from "./Container/WizardContainer";

const ContactUsStep = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("yourchoises");
  const cartProduct = useCartProduct();
  const cartOptional = useCartOptional();
  const machineTonnage = useMachineTonnage();
  const isLoadedFromSummary = useIsLoadedFromSummary();
  const cookieMarket = cookies.getMarket();
  const [episerverUrl, setEpiserverUrl] = useState<string>("");
  const episerverLinks = useEpiserverLink();
  const searchParams = new URLSearchParams(document.location.search);
    const summaryId = searchParams.get("id");
    if (!machineTonnage && !summaryId) {
    const routeMarket = cookieMarket ? cookieMarket : "en";
    window.location.href = routesConfig[routeMarket].machineTonnageStep;
  }

    useEffect(() => {
        if (episerverLinks) {
    const url = `${process.env.REACT_APP_URLPATH}${
      episerverLinks[EpiId.Retailer]
    }`;
    setEpiserverUrl(url);
        }

  }, [episerverLinks]);

  useEffect(() => {
    dispatch(
      action.saveWizard({
        activeStepIndex: WizardStepIndex.ContactUs,
        enableNext: false,
      })
    );
  }, [dispatch, machineTonnage]);

    useEffect(() => {
        if (summaryId) {
            getPdb(`api/summary/${summaryId}`).then((summary) => {
                dispatch(action.restoreStateFromSummary(summary));
            });
        }
    }, [summaryId]);

  return (
    <WizardContainer>
      <div>
        <div className="formComponent">
          <div className="firstHeader">
            <h1>{t("yourchoises")}</h1>
            {!isLoadedFromSummary && <p>{t("yourchoisesintro")}</p>}
          </div>
          {!isLoadedFromSummary && (
            <>
              <div className="secondHeading">
                <h2>{t("yourinformation")}</h2>
                <RetailerLink
                  linkText={t("viewretailers").toUpperCase()}
                  url={episerverUrl}
                />
              </div>
              <ContactUsForm
                cartOptional={cartOptional}
                cartProduct={cartProduct}
              />
            </>
          )}
        </div>
        <ProductsList
          cartOptional={cartOptional}
          cartProduct={cartProduct}
          isLoadedFromSummary={isLoadedFromSummary}
        />
        <div>
          <DisclamerText />
        </div>
      </div>
    </WizardContainer>
  );
};

export default ContactUsStep;
